export default "__VITE_ASSET__75747f2b__"